<p-confirmDialog />

<div class="future-allocation-page">

  <!-- Stats cards on top (reuses global .stats-cards-row / .stats-card) -->
  <div class="stats-cards-row">
    <div class="stats-card stats-card--total">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ avgUtilization }}%</span>
        <span class="stats-card-label">Avg Utilization</span>
        <span class="stats-card-sublabel">across the 12-month window</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-chart-line"></i></div>
    </div>
    <div class="stats-card stats-card--danger">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ overAllocatedCount }}</span>
        <span class="stats-card-label">Over-allocated</span>
        <span class="stats-card-sublabel">employee-months &gt; 100%</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-exclamation-triangle"></i></div>
    </div>
    <div class="stats-card stats-card--warning">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ underUtilizedCount }}</span>
        <span class="stats-card-label">Under 50%</span>
        <span class="stats-card-sublabel">low forecast capacity</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-chart-pie"></i></div>
    </div>
    <div class="stats-card stats-card--success">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ fullyBookedCount }}</span>
        <span class="stats-card-label">Fully Booked</span>
        <span class="stats-card-sublabel">100% every month</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
    </div>
  </div>

  <!-- Action bar BELOW cards — reuses the Allocation page's .controls-section styles -->
  <div class="controls-section sticky-controls fa-toolbar mb-4">
    <div class="controls-left">
      <div class="fa-seg">
        <button type="button" [class.active]="half === 0" (click)="setHalf(0)">
          <i class="pi pi-angle-left"></i> Jan–Jun
        </button>
        <button type="button" [class.active]="half === 1" (click)="setHalf(1)">
          Jul–Dec <i class="pi pi-angle-right"></i>
        </button>
      </div>

      <p-button
        *ngIf="canExport"
        label="Export Excel"
        icon="pi pi-file-excel"
        (onClick)="exportToExcel()"
        severity="success"
        styleClass="btn-export-excel" />

      <p-button
        [label]="'Unallocated (' + unallocatedCount + ')'"
        icon="pi pi-eye"
        (onClick)="openUnallocatedDialog()"
        severity="secondary"
        styleClass="btn-unallocated" />
    </div>
    <div class="page-header-actions-right">
      <div class="page-header-search">
        <div class="search-box">
          <i class="pi pi-search"></i>
          <input pInputText type="text" [ngModel]="searchText" (ngModelChange)="onSearch($event)"
            class="search-input" placeholder="Search employee, project..." aria-label="Search" />
        </div>
      </div>
      <p-button *ngIf="canWrite" label="Add Allocation" icon="pi pi-plus" severity="primary" (onClick)="openAddDialog()" />
    </div>
  </div>

  <!-- Filters (reuses global .filter-bar) -->
  <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
    <div class="filter-bar-filters">
      <div class="filter-field">
        <label class="filter-label">Role</label>
        <p-multiSelect [(ngModel)]="selectedRoles" (ngModelChange)="applyFilters()"
          [options]="roleFilterOptions" optionLabel="label" optionValue="value" placeholder="All Roles"
          display="chip" [showToggleAll]="true" [filter]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
        <label class="filter-label">PM</label>
        <p-multiSelect [(ngModel)]="selectedPMs" (ngModelChange)="applyFilters()"
          [options]="pmOptions" optionLabel="label" optionValue="value" placeholder="All PMs"
          display="chip" [showToggleAll]="true" [filter]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
        <label class="filter-label">Project</label>
        <p-multiSelect [(ngModel)]="selectedProjects" (ngModelChange)="applyFilters()"
          [options]="projectOptions" optionLabel="label" optionValue="value" placeholder="All projects"
          display="chip" [showToggleAll]="true" [filter]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
        <label class="filter-label">Invoice Type</label>
        <p-multiSelect [(ngModel)]="selectedInvoiceTypes" (ngModelChange)="applyFilters()"
          [options]="invoiceTypeOptions" optionLabel="label" optionValue="value" placeholder="Invoice Type"
          display="chip" [showToggleAll]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
        <label class="filter-label">Cost Center</label>
        <p-multiSelect [(ngModel)]="selectedCostCenters" (ngModelChange)="applyFilters()"
          [options]="costCenterFilterOptions" optionLabel="label" optionValue="value" placeholder="All Cost Centers"
          display="chip" [showToggleAll]="true" [filter]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
        <label class="filter-label">Service Group</label>
        <p-multiSelect [(ngModel)]="selectedServiceGroups" (ngModelChange)="applyFilters()"
          [options]="serviceGroupOptions" optionLabel="label" optionValue="value" placeholder="All service groups"
          display="chip" [showToggleAll]="true" [filter]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field filter-field--checkbox">
        <label class="availability-toggle" for="faAvailabilityFilter">
          <p-checkbox inputId="faAvailabilityFilter" [(ngModel)]="showOnlyAvailable"
            (ngModelChange)="applyFilters()" [binary]="true" />
          <span>Has Availability</span>
        </label>
      </div>
    </div>
    <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
      <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
        <i class="pi pi-filter-slash"></i>
      </button>
    </div>
  </div>

  <!-- Grid -->
  <p-table [value]="displayRows" [loading]="loading" [scrollable]="true" scrollHeight="flex"
    [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }" styleClass="future-allocation-table resize-handles-visible"
    [resizableColumns]="true" columnResizeMode="fit">
    <ng-template pTemplate="header">
      <tr>
        <!-- Not sortable by design: rows are grouped (project rows + per-employee total
             rows, ordered by employee then project). Column sorting would separate the
             total rows from the groups they summarise. Identity columns resize only. -->
        <th pResizableColumn class="fa-col-employee">Employee</th>
        <th pResizableColumn class="fa-col-project">Project / PM</th>
        <th pResizableColumn class="fa-col-invoice">Invoice</th>
        <th class="fa-col-month" *ngFor="let m of visibleMonths">{{ m.label }}</th>
        <th *ngIf="canWrite" class="fa-col-actions">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-d>
      <!-- Project row -->
      <tr *ngIf="d.kind === 'project'">
        <td class="fa-cell-employee allocation-cell-employee">
          <ng-container *ngIf="d.row.isFirstInGroup">
            <div class="table-employee-wrap table-cell-hover"
              [pTooltip]="d.row.employeeName + '\n' + employeeSubLabel(d.row)" tooltipPosition="top">
              <span class="table-employee-avatar">{{ getInitials(d.row.employeeName) }}</span>
              <div class="table-employee-info">
                <span class="table-employee-name">{{ d.row.employeeName }}</span>
                <!-- role · cost centre · service group — matches the Monthly Allocation grid. -->
                <span class="table-employee-role">{{ employeeSubLabel(d.row) }}</span>
              </div>
            </div>
            <!-- Divider under the employee block, same as the Monthly Allocation grid — it separates
                 one employee's group from the next now that per-row lines are gone. -->
            <div class="allocation-employee-divider"></div>
          </ng-container>
        </td>
        <td class="fa-cell-project">
          <span class="fa-project-name">
            {{ d.row.projectName }}
            <span class="presales-chip" *ngIf="d.row.isProjectPresales"
                  pTooltip="In-pursuit presales deal — not yet won" tooltipPosition="top">Presales</span>
          </span>
          <span class="fa-project-pm">PM: {{ d.row.managerName || '—' }}</span>
        </td>
        <td class="fa-cell-invoice">
          <span class="invoice-type-badge invoice-type-badge--{{ getInvoiceTypeSeverity(d.row.invoiceType) }}">
            <i class="pi pi-circle-fill invoice-type-badge-dot" aria-hidden="true"></i>
            {{ getInvoiceTypeLabel(d.row.invoiceType) }}
          </span>
        </td>
        <td class="fa-cell-month allocation-cell-week" *ngFor="let m of visibleMonths">
          <div class="allocation-week-cell">
            <div class="allocation-week-track">
              <div class="allocation-week-bar" [ngClass]="'allocation-week-bar--' + getWeekPercentSeverity(getCellPercent(d.row, m))"
                [style.width.%]="getCellPercent(d.row, m)"></div>
            </div>
            <!-- Always render "N%" (including 0%), matching the Monthly Allocation week cells —
                 a bare em-dash lost the amber zero signal. -->
            <span class="allocation-week-value" [ngClass]="'allocation-week-value--' + getWeekPercentSeverity(getCellPercent(d.row, m))">
              {{ getCellPercent(d.row, m) }}%
            </span>
          </div>
        </td>
        <td *ngIf="canWrite" class="fa-cell-actions">
          <div class="table-actions-stack">
            <p-button icon="pi pi-plus-circle" [text]="true" severity="success" size="small"
              (onClick)="quickAddForRow(d.row, $event)"
              pTooltip="Add allocation for this employee" tooltipPosition="top" ariaLabel="Add allocation for this employee" />
            <p-button icon="pi pi-pencil" [text]="true" severity="info" size="small"
              (onClick)="openEditDialog(d.row)" ariaLabel="Edit allocation" />
            <p-button icon="pi pi-trash" [text]="true" severity="danger" size="small"
              (onClick)="deleteRow(d.row, $event)" ariaLabel="Remove allocation" />
          </div>
        </td>
      </tr>

      <!-- Synthetic "Available" row: remaining capacity per month (only shown when any month has remaining) -->
      <tr *ngIf="d.kind === 'available'" class="available-computed-row"
        pTooltip="Remaining capacity across all projects this month" tooltipPosition="left">
        <td class="fa-cell-employee"></td>
        <td class="fa-cell-project">
          <span class="fa-project-name available-computed-label">Available</span>
          <span class="fa-project-pm available-computed-meta">Remaining capacity</span>
        </td>
        <td class="fa-cell-invoice"></td>
        <td class="fa-cell-month allocation-cell-week" *ngFor="let m of visibleMonths">
          <div class="allocation-week-cell">
            <div class="allocation-week-track">
              <div class="allocation-week-bar allocation-week-bar--available"
                [style.width.%]="getAvailableForMonth(d.availableByKey, m)"></div>
            </div>
            <span class="allocation-week-value allocation-week-value--available">
              {{ getAvailableForMonth(d.availableByKey, m) }}%
            </span>
          </div>
        </td>
        <td *ngIf="canWrite" class="fa-cell-actions"></td>
      </tr>

      <!-- Per-employee monthly total — closes the block, after Available. Same markup, classes and
           severity colours as the Monthly Allocation grid, so 0% / 100% / over-allocated read
           identically on both pages. The label sits in the EMPLOYEE column, matching that page. -->
      <tr *ngIf="d.kind === 'total'" class="allocation-row-total"
        pTooltip="Total allocated across all projects this month" tooltipPosition="left">
        <td class="fa-cell-employee allocation-cell-total-label">{{ d.employeeName }} — Total</td>
        <td class="fa-cell-project"></td>
        <td class="fa-cell-invoice"></td>
        <!-- Same track + bar + value structure as the month cells above (and as the Monthly
             Allocation total row), so both pages read identically. Bar caps at 100% width; the
             value still shows the true figure (e.g. 125%). -->
        <td class="fa-cell-month allocation-cell-week allocation-cell-total-value" *ngFor="let m of visibleMonths">
          <div class="allocation-week-cell">
            <div class="allocation-week-track">
              <div class="allocation-week-bar allocation-week-bar--total"
                [ngClass]="'allocation-week-bar--' + getWeekPercentSeverity(getTotalForMonth(d.totalByKey, m))"
                [style.width.%]="getTotalForMonth(d.totalByKey, m) > 100 ? 100 : getTotalForMonth(d.totalByKey, m)"></div>
            </div>
            <span class="allocation-week-value allocation-total-value"
              [ngClass]="'allocation-week-value--' + getWeekPercentSeverity(getTotalForMonth(d.totalByKey, m))">
              {{ getTotalForMonth(d.totalByKey, m) }}%
            </span>
          </div>
        </td>
        <td *ngIf="canWrite" class="fa-cell-actions"></td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr class="table-empty-row">
        <td [attr.colspan]="visibleMonths.length + 4" class="table-empty-cell">
          <div class="empty-state">
            <div class="empty-icon"><i class="pi pi-inbox"></i></div>
            <p class="empty-message">No future allocations found</p>
            <p class="empty-description">Click "Add Allocation" to plan capacity for the next 12 months.</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

</div>

<!-- ============ Add / Edit dialog — reuses the Add Allocation form styles ============ -->
<p-dialog [(visible)]="displayDialog" [header]="isEditMode ? 'Edit Future Allocation' : 'Add Future Allocation'"
  [modal]="true" styleClass="dialog-xl allocation-form-dialog" [dismissableMask]="true" [closable]="true"
  [style]="{ width: '780px' }">

  <div class="p-fluid form-dialog-container form-dialog-form form-dialog-spacious allocation-form">
    <!-- ===== Section: Details ===== -->
    <div class="alloc-section alloc-section--details">
      <div class="alloc-section-head">
        <i class="pi pi-user"></i>
        <span>Allocation details</span>
      </div>
    <!-- Details -->
    <div class="form-row two-columns allocation-details-row">
      <div class="field" [class.field-invalid]="fieldTouched['employeeId'] && !formEmployeeId">
        <label for="fa-employee">Employee *</label>
        <p-select inputId="fa-employee" [(ngModel)]="formEmployeeId" (ngModelChange)="onFormEmployeeChange()"
          (onBlur)="fieldTouched['employeeId'] = true"
          [options]="employees" optionLabel="name" optionValue="id" placeholder="Select an employee"
          [filter]="true" [showClear]="true" [disabled]="isEditMode" appendTo="body" />
        <small class="field-error" *ngIf="fieldTouched['employeeId'] && !formEmployeeId">Please select an employee</small>
      </div>
      <div class="field">
        <label for="fa-role">Role</label>
        <p-select inputId="fa-role" [(ngModel)]="formRoleId" [options]="allocationRoleOptions" optionLabel="label" optionValue="value"
          placeholder="Select a role" [showClear]="true" appendTo="body" [filter]="true" filterPlaceholder="Search…" />
        <small *ngIf="formEmployeeId && allocationRoleOptions.length === 0" class="p-text-secondary">
          No roles assigned to this employee. Assign roles on the Employee page.
        </small>
      </div>
    </div>

    <!-- Available Capacity card (mirrors the Allocation form) — shows free % per shown month -->
    <div class="field grid" *ngIf="showAvailableCard">
      <div class="col-12">
        <div class="available-percentage-card">
          <div class="card-header">
            <div class="card-header-left">
              <i class="pi pi-info-circle"></i>
              <span>Available Capacity</span>
            </div>
            <p-button label="Fill with Available" icon="pi pi-check" (onClick)="fillAllWithAvailable()"
              severity="success" size="small" />
          </div>
          <div class="card-content">
            <div class="capacity-grid">
              <!-- Available capacity is never negative: once a month is over-allocated there is
                   simply 0% left, so the value is clamped and the card carries no over-allocation
                   highlight. The over state belongs on the percentage fields below, which is where
                   the excess was actually entered. -->
              <div class="capacity-item" *ngFor="let fm of (showSecondHalf ? formMonths : formMonthsFirstHalf)">
                <span class="week-label">{{ fm.label }}</span>
                <span class="percentage-value">{{ monthAvailable(fm) }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-row two-columns allocation-details-row">
      <div class="field" [class.field-invalid]="fieldTouched['projectId'] && !formProjectId">
        <label for="fa-project">Project *</label>
        <p-select inputId="fa-project" [(ngModel)]="formProjectId" (ngModelChange)="onFormProjectChange()"
          (onBlur)="fieldTouched['projectId'] = true"
          [options]="projects" optionLabel="name" optionValue="id" placeholder="Select a project"
          [filter]="true" [showClear]="true" [disabled]="isEditMode" appendTo="body" />
        <small class="field-error" *ngIf="fieldTouched['projectId'] && !formProjectId">Please select a project</small>
      </div>
      <div class="field">
        <label for="fa-invoice">Invoice Type</label>
        <p-select inputId="fa-invoice" [(ngModel)]="formInvoiceType" [options]="invoiceTypeOptions" optionLabel="label"
          optionValue="value" placeholder="Select invoice type" appendTo="body" />
      </div>
    </div>

    <div class="form-row two-columns allocation-details-row">
      <div class="field">
        <label for="fa-costcenter">Cost Center</label>
        <p-select inputId="fa-costcenter" [(ngModel)]="formCostCenterId" [options]="costCenterOptions" optionLabel="label"
          optionValue="value" placeholder="Select a cost center" [filter]="true" [showClear]="true" appendTo="body" />
      </div>
      <div class="field">
        <label for="fa-servicegroup">Service Group</label>
        <p-select inputId="fa-servicegroup" [(ngModel)]="formServiceGroupId" [options]="serviceGroupOptions"
          optionLabel="label" optionValue="value" placeholder="Auto-filled from employee / project"
          [disabled]="true" appendTo="body" [filter]="true" filterPlaceholder="Search…" />
      </div>
    </div>
    </div><!-- /fa-section--details -->

    <!-- ===== Section: Monthly Percentages ===== -->
    <div class="alloc-section alloc-section--periods monthly-percentages-section">
      <div class="monthly-percentages-header">
        <label class="monthly-percentages-title"><i class="pi pi-calendar"></i> Monthly Percentages</label>
        <div class="monthly-quickfill">
          <span class="monthly-quickfill-label">Set all</span>
          <p-inputNumber [(ngModel)]="applyAllValue" [min]="0" [max]="100" [showButtons]="false"
            suffix="%" inputStyleClass="monthly-quickfill-input" />
          <p-button label="Apply" icon="pi pi-arrow-down" (onClick)="applyAllMonths()"
            severity="info" size="small" pTooltip="Fill the shown months" tooltipPosition="top" />
        </div>
      </div>

      <!-- First 6 months -->
      <div class="month-percentages-columns">
        <div class="month-percentage-col" *ngFor="let fm of formMonthsFirstHalf" [class.month-col-over]="monthIsOver(fm)">
          <label class="month-col-label">{{ fm.label }}</label>
          <div class="month-col-meta">
            <span class="remaining-badge" [ngClass]="{ 'over-allocated': monthIsOver(fm) }">
              {{ monthIsOver(fm) ? 'Over: ' + (-monthRemaining(fm)) : 'Remaining: ' + monthRemaining(fm) }}%
            </span>
          </div>
          <a class="use-available-link" [class.disabled]="monthAvailable(fm) <= 0"
            (click)="monthAvailable(fm) > 0 && useAvailableForMonth(fm)">
            <i class="pi pi-arrow-right"></i> Use Available
          </a>
          <p-select [(ngModel)]="fm.percentage" (ngModelChange)="onMonthPercentageChange(fm, $event)"
            [options]="percentageOptions" optionLabel="label" optionValue="value"
            [editable]="true" placeholder="%" appendTo="body" styleClass="month-select w-full" />
        </div>
      </div>

      <!-- Remaining 6 months — one continuous grid with the block above. The old "Add next 6 months"
           reveal is gone: all 12 months are always shown, so there is nothing left to reveal. -->
      <div class="month-percentages-columns second-half">
        <div class="month-percentage-col" *ngFor="let fm of formMonthsSecondHalf" [class.month-col-over]="monthIsOver(fm)">
          <label class="month-col-label">{{ fm.label }}</label>
          <div class="month-col-meta">
            <span class="remaining-badge" [ngClass]="{ 'over-allocated': monthIsOver(fm) }">
              {{ monthIsOver(fm) ? 'Over: ' + (-monthRemaining(fm)) : 'Remaining: ' + monthRemaining(fm) }}%
            </span>
          </div>
          <a class="use-available-link" [class.disabled]="monthAvailable(fm) <= 0"
            (click)="monthAvailable(fm) > 0 && useAvailableForMonth(fm)">
            <i class="pi pi-arrow-right"></i> Use Available
          </a>
          <p-select [(ngModel)]="fm.percentage" (ngModelChange)="onMonthPercentageChange(fm, $event)"
            [options]="percentageOptions" optionLabel="label" optionValue="value"
            [editable]="true" placeholder="%" appendTo="body" styleClass="month-select w-full" />
        </div>
      </div>
    </div><!-- /fa-section--months -->

    <!-- ===== Section: Comments ===== -->
    <div class="alloc-section alloc-section--comments">
      <div class="alloc-section-head">
        <i class="pi pi-comment"></i>
        <span>Comments</span>
      </div>
      <textarea id="fa-comments" [(ngModel)]="formComments" rows="3" class="p-inputtext fa-comments-input"
        placeholder="Enter any notes about this allocation…"></textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns fa-dialog-footer">
      <!-- Over-allocation is surfaced as a toast when the value is entered (same as the Allocation
           form), not as permanent footer text. -->
      <p-button label="Reset" icon="pi pi-refresh" severity="secondary" [text]="true" (onClick)="resetForm()" />
      <p-button label="Cancel" severity="secondary" [text]="true" (onClick)="displayDialog = false" />
      <p-button label="Save allocation" icon="pi pi-check" severity="primary" [disabled]="!canSaveForm" (onClick)="saveForm()" />
    </div>
  </ng-template>
</p-dialog>

<!-- ============ Un-Allocated Employees dialog — mirrors the Allocation page popup ============ -->
<p-dialog [(visible)]="displayUnallocatedDialog" [modal]="true"
  styleClass="dialog-xl unallocated-employees-dialog" [dismissableMask]="true" [closable]="true"
  [style]="{ width: '900px' }">

  <ng-template pTemplate="header">
    <div class="dialog-header-with-meta">
      <span class="dialog-header-title">Un-Allocated Employees</span>
      <span class="dialog-header-badge">{{ unallocatedEmployees.length }}</span>
      <span class="dialog-header-period">Calendar year {{ selectedYear }}</span>
    </div>
  </ng-template>

  <div class="unallocated-dialog-inner">
    <div class="unallocated-table-scroll-holder">
      <p-table [value]="unallocatedEmployees" [paginator]="true" [alwaysShowPaginator]="false" [rows]="20"
        [tableStyle]="{ 'min-width': '100%' }" styleClass="compact-striped-table unallocated-dialog-table">
        <ng-template pTemplate="header">
          <tr>
            <th class="unallocated-col-name">Employee Name</th>
            <th class="unallocated-col-email">Email</th>
            <th class="unallocated-col-role">Role</th>
            <th class="unallocated-col-designation">Designation</th>
            <th class="unallocated-col-category">Category</th>
            <th class="unallocated-col-service">Service Group</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-employee>
          <tr>
            <td class="unallocated-cell-name">
              <button type="button" class="unallocated-name-link"
                (click)="openAddAllocationForEmployee(employee)"
                [pTooltip]="'Add allocation for ' + employee.name" tooltipPosition="top">{{ employee.name }}</button>
            </td>
            <td class="unallocated-cell-email"><span class="unallocated-cell-text" [pTooltip]="(employee.email || '-')" tooltipPosition="top">{{ employee.email || '-' }}</span></td>
            <td class="unallocated-cell-role"><span class="unallocated-cell-text" [pTooltip]="getRoleName(employee.roleId)" tooltipPosition="top">{{ getRoleName(employee.roleId) }}</span></td>
            <td class="unallocated-cell-designation"><span class="unallocated-cell-text" [pTooltip]="(employee.designationName || '-')" tooltipPosition="top">{{ employee.designationName || '-' }}</span></td>
            <td class="unallocated-cell-category"><span class="unallocated-cell-text" [pTooltip]="(employee.categoryName || '-')" tooltipPosition="top">{{ employee.categoryName || '-' }}</span></td>
            <td class="unallocated-cell-service"><span class="unallocated-cell-text" [pTooltip]="(employee.serviceGroupName || getServiceGroupName(employee.serviceGroupId))" tooltipPosition="top">{{ employee.serviceGroupName || getServiceGroupName(employee.serviceGroupId) }}</span></td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center empty-message-text p-4">
              All eligible employees have a future allocation in this window.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Close" icon="pi pi-times" (onClick)="hideUnallocatedDialog()" severity="secondary" />
    <p-button label="Export Excel" icon="pi pi-file-excel" (onClick)="exportUnallocatedToExcel()" severity="success" />
  </ng-template>
</p-dialog>
